<div *ngIf="location" class="location-search" [formGroup]="locationForm">
  <mat-icon
    *ngIf="!modalOpen"
    class="location-search__icon"
    matPrefix
    [svgIcon]="field.icon"
    role="presentation"
  ></mat-icon>
  <input
    formControlName="location"
    type="search"
    class="location-search__input"
    [class.location-search__input--error]="error$ | async"
    #workplaceTextfieldRef
    matInput
    (focus)="locationIsFocused = true"
    (blur)="locationIsFocused = false"
    [matAutocomplete]="auto"
    [placeholder]="field.placeholder"
    [attr.aria-label]="field.ariaLabel"
    [class.location-search__input--border]="modalOpen"
  />

  <mat-form-field
    *ngIf="location.value?.type === WorkplaceTypeEnum.city"
    [class.dropdown--simple]="!modalOpen"
    class="dropdown location-search__dropdown location-search__dropdown--distance"
    floatLabel="never"
    [attr.dropdownOpen]="distanceSelect.panelOpen"
    [attr.dropdownSelected]="!!distanceSelect?.value"
    appearance="legacy"
  >
    <mat-select
      formControlName="distance"
      panelClass="dropdown-panel dropdown-panel-search"
      #distanceSelect="matSelect"
      aria-label="Rayon de recherche"
    >
      <mat-option *ngFor="let distance of distanceSearch; trackBy: trackByDistanceSearch" [value]="distance.value">{{
        distance.libelle
      }}</mat-option>
    </mat-select>
    <mat-icon matSuffix svgIcon="arrow_next" role="presentation"></mat-icon>
  </mat-form-field>
  <button
    *ngIf="!!value"
    type="button"
    class="delete-btn btn-clean location-search__btn-delete"
    [class.location-search__btn-delete--distance]="location.value?.type === WorkplaceTypeEnum.city"
    [attr.aria-label]="'Suppression du filtre ' + field.ariaLabel | lowercase | upperfirst"
    (click)="clearValue($event)"
  >
    <mat-icon svgIcon="cross" class="location-search__icon--delete" role="presentation"></mat-icon>
  </button>

  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    class="dropdown-panel dropdown-panel--search-engine"
    [displayWith]="displayFn"
    (closed)="onClose()"
    [panelWidth]="300"
  >
    <ng-container *ngIf="regions$ | async as regions">
      <mat-optgroup *ngIf="regions.hits.length > 0" label="Régions">
        <mat-option
          *ngFor="let region of regions.hits; trackBy: trackByPoleEmploiRegion"
          [value]="{ workplace: region, type: WorkplaceTypeEnum.region }"
          >{{ region.libelle }}</mat-option
        >
      </mat-optgroup>
    </ng-container>

    <ng-container *ngIf="departments$ | async as departments">
      <mat-optgroup *ngIf="departments.hits.length > 0" label="Départements">
        <mat-option
          *ngFor="let department of departments.hits; trackBy: trackByPoleEmploiDepartment"
          [value]="{ workplace: department, type: WorkplaceTypeEnum.department }"
          >{{ department.libelle }}</mat-option
        >
      </mat-optgroup>
    </ng-container>

    <ng-container *ngIf="cities$ | async as cities">
      <mat-optgroup *ngIf="cities.hits.length > 0" label="Communes">
        <mat-option
          *ngFor="let city of cities.hits; trackBy: trackByPoleEmploiCity"
          [value]="{ workplace: city, type: WorkplaceTypeEnum.city }"
          >{{ city.libelle }} - {{ city.codePostal }}</mat-option
        >
      </mat-optgroup>
    </ng-container>

    <ng-container *ngIf="(error$ | async) === true">
      <mat-optgroup label="Aucune suggestion ne correspond à votre saisie." class="mat-optgroup--error">
        <mat-option class="mat-option--error">
          Vérifiez qu&apos;il s&apos;agisse bien d&apos;un lieu ou qu&apos;il ne comporte pas de faute.
        </mat-option>
      </mat-optgroup>
    </ng-container>
  </mat-autocomplete>
</div>
